import React, { Component } from 'react';
import SimpleLayout from './SimpleLayout';
import Agb from '../footer/Agb';
import '../css/style.css';
import '../components/Home.css';

class AgbLayout extends Component {

    render(){
        return (
            <SimpleLayout>
                <Agb />
            </SimpleLayout>              
        );
    }

}

export default AgbLayout;